var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"admin"}},[_c('AdminNav'),_c('AdminTable'),(_vm.$store.state.adminData.showTrailSystem)?_c('AdminTrailSystem'):_vm._e(),(_vm.$store.state.adminData.changeOwner)?_c('AdminChangeOwner'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }